import { render, staticRenderFns } from "./textAlign-editor.vue?vue&type=template&id=5dd5eb42&scoped=true"
import script from "./textAlign-editor.vue?vue&type=script&lang=js"
export * from "./textAlign-editor.vue?vue&type=script&lang=js"
import style0 from "./textAlign-editor.vue?vue&type=style&index=0&id=5dd5eb42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5eb42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd5eb42')) {
      api.createRecord('5dd5eb42', component.options)
    } else {
      api.reload('5dd5eb42', component.options)
    }
    module.hot.accept("./textAlign-editor.vue?vue&type=template&id=5dd5eb42&scoped=true", function () {
      api.rerender('5dd5eb42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/textAlign-editor.vue"
export default component.exports